angular.module('impactx.filebrowser').controller('FileBrowserListCtrl', [
    'selectedListItems',
    'FileHelperService',
    '$routeParams',
    'NewWindowService',
    'ToastService',
    'dataGen',
    'TranslationService',
    '$route',
    '$mdDialog',
    'ConfirmationService',
    '$scope',
    '$securityManager',
    '$listCache',
    '$redirect',
    FileBrowserListCtrl
]);

function FileBrowserListCtrl(selectedListItems, FileHelperService, $routeParams, NewWindowService, ToastService, dataGen,
                             TranslationService, $route, $mdDialog, ConfirmationService, $scope,
                             $securityManager, $listCache, $redirect) {
    var ctrl = this;

    selectedListItems.clearSelectedItems();

    ctrl.openFile = function () {
        NewWindowService.openNewWindow(selectedListItems.getFirstSelectedItem().link, '_blank');
    };

    ctrl.redirectToFolder = function () {
        if (ctrl.meta.params.listConfig.filterBlocks) {
            var filterBlocks = ctrl.meta.params.listConfig.filterBlocks;
            for (var j = 0; j < filterBlocks.length; j++) {
                var filters = filterBlocks[j].filterValues;
                for (var i = 0; i < filters.length; i++) {
                    filters[i].stringValue = "";
                }
            }
        }
        $redirect.redirectTo(null, "filebrowser/" + ($routeParams.path ? ($routeParams.path + "\\") : "") + selectedListItems.getFirstSelectedItem().name);
    };

    ctrl.isFolderAndCanOpen = function () {
        if (selectedListItems.isSingleSelection()) {
            var selectedItem = selectedListItems.getFirstSelectedItem();
            if (selectedItem && selectedItem.isFolder) {
                return true;
            }
        }
        return false;
    };

    ctrl.isFileAndCanOpen = function () {
        if (selectedListItems.isSingleSelection()) {
            var selectedItem = selectedListItems.getFirstSelectedItem();
            if (selectedItem && !selectedItem.isFolder) {
                return true;
            }
        }
        return false;
    };

    ctrl.newFolder = function (event, trns) {
        $mdDialog.show({
            templateUrl: 'modules/filebrowser/templates/foldername.dialog.tmpl.html',
            controller: "FolderNameDialogCtrl",
            controllerAs: "folderNameDialogCtrl",
            targetEvent: event,
            locals: {
                header: trns.folderNameHeader,
                inputLabel: trns.folderInputLabel
            },
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        }).then(function (folderName) {
            if (folderName) {
                var dataObject = {
                    subPath: $routeParams.path,
                    folderName: folderName
                };
                dataGen.postAsForm({}, dataObject, "/filebrowser/newfolder").then(function () {
                    $route.reload();
                    ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                });
            }
        });
    };

    ctrl.delete = function (event, trns) {
        ConfirmationService.showConfirmationDialog(ctrl.realDelete, event, trns.confirmDelete,
            TranslationService.get("delete"), TranslationService.get("abort"));
    };

    ctrl.realDelete = function () {
        var selectedItems = selectedListItems.getSelectedItems();
        var toDelete = [];
        for (var i = 0; i < selectedItems.length; i++) {
            toDelete.push({value: selectedItems[i].name});
        }
        var dataObject = {
            subPath: $routeParams.path,
            fileNames: toDelete
        };
        dataGen.postAsForm({}, dataObject, "/filebrowser/delete").then(function () {
            $route.reload();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    ctrl.uploadFile = function () {
        angular.element(document.querySelector('#fileInputFileBrowser')).click();
    };

    ctrl.handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        $(this).val("");
        ctrl.handleFile(evt, file);
    };

    this.handleFile = function (evt, file) {
        if (!FileHelperService.checkAllowedFileWithError(file.name)) {
            return;
        }

        var fileData = {
            file: file,
            fileName: file.name,
            subPath: $routeParams.path !== undefined ? $routeParams.path : ""
        };

        dataGen.uploadFile(fileData, '/filebrowser/upload').then(function () {
            $route.reload();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        }, angular.noop);
    };

    var buttonDefinition = [{
        label: "open",
        action: ctrl.redirectToFolder,
        condition: ctrl.isFolderAndCanOpen,
        process: 'FileBrowserView'
    }, {
        label: "open",
        action: ctrl.openFile,
        condition: ctrl.isFileAndCanOpen,
        process: 'FileBrowserView'
    }, {
        label: "newFolder",
        action: ctrl.newFolder,
        condition: selectedListItems.isNoSelection,
        process: 'FileBrowserEdit'
    }, {
        label: "delete",
        action: ctrl.delete,
        condition: selectedListItems.isMultiSelection,
        process: 'FileBrowserEdit'
    }];

    ctrl.meta = {
        rowTemplate: 'modules/filebrowser/templates/filebrowserlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/filebrowser/list',
        id: "filebrowserlist",
        buttonDefinition: buttonDefinition,
        fileHelperService: FileHelperService,
        valuesString: [
            {
                name: "path",
                value: $routeParams.path
            }
        ],
        handleFileSelect: ctrl.handleFileSelect,
        mainActionFunction: {
            id: "upload",
            action: ctrl.uploadFile,
            icon: "mdi-upload"
        }
    };
    ctrl.getMeta = function () {
        return this.meta;
    };
}

angular.module('impactx.filebrowser').directive('fileChange', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var onChangeHandler = scope.$eval(attrs.fileChange);
            element.on('change', onChangeHandler);
            element.on('$destroy', function () {
                element.off();
            });

        }
    };
});

